import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _sortBy from "lodash/sortBy";
import _get from "lodash/get";
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { CONTENT_PREVIEW_PARAMETER, convertSeoMetaResponseToSeoMeta, retrieveColorLogos } from './util';
var URL_PATH = "/content/entries/landingPageDemoRequest";
export var fetchAllDemoRequestPages = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(client, options) {
    var url, response, transformedResponse;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            url = process.env.ENVIRONMENT === "staging" ? "".concat(URL_PATH, "?").concat(CONTENT_PREVIEW_PARAMETER, "=true") : URL_PATH;
            _context2.next = 3;
            return client.get(url, options);

          case 3:
            response = _context2.sent;
            _context2.next = 6;
            return Promise.all(response.map( /*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(templatePage) {
                var logos;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return retrieveColorLogos(client, templatePage.logoGrid);

                      case 2:
                        logos = _context.sent;
                        return _context.abrupt("return", _objectSpread(_objectSpread({}, templatePage), {}, {
                          form: {
                            overline: _get(templatePage, "formOverline", ""),
                            heading: _get(templatePage, "formHeading", ""),
                            description: _get(templatePage, "formDescription", ""),
                            formId: _get(templatePage, "demoFormId", "")
                          },
                          logoGrid: {
                            heading: _get(templatePage, "logoGridHeading", ""),
                            description: _get(templatePage, "logoGridDescription", ""),
                            logos: logos
                          },
                          seo: convertSeoMetaResponseToSeoMeta(_get(templatePage, "seo.fields", {}))
                        }));

                      case 4:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x3) {
                return _ref2.apply(this, arguments);
              };
            }()));

          case 6:
            transformedResponse = _context2.sent;
            return _context2.abrupt("return", _sortBy(transformedResponse, function (item) {
              return item.title;
            }));

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchAllDemoRequestPages(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export var fetchDemoRequestPage = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref3) {
    var client, options, slug, templatePages, data;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            client = _ref3.client, options = _ref3.options, slug = _ref3.slug;
            _context3.next = 3;
            return fetchAllDemoRequestPages(client, options);

          case 3:
            templatePages = _context3.sent;
            data = templatePages.find(function (item) {
              return item.slug === slug;
            });
            return _context3.abrupt("return", data);

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function fetchDemoRequestPage(_x4) {
    return _ref4.apply(this, arguments);
  };
}();